// extracted by mini-css-extract-plugin
export default {"container":"hb","hidden":"ib","column":"jb","headline":"kb"};